import api from './api';

export interface Referral {
  id: number;
  name: string;
  hash: string;
  phone: string | null;
  email: string | null;
  logo: string | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface ReferralCreate {
  name: string;
  phone?: string | null;
  email?: string | null;
  logo?: string | null;
}

export type ReferralUpdate = Partial<ReferralCreate>;

// Lightweight id/name pairs, readable by any user in the tenant
export interface ReferralOption {
  id: number;
  name: string;
}

export const referralService = {
  async getReferrals(): Promise<Referral[]> {
    const response = await api.get('/referrals/');
    return response.data;
  },

  async getReferralOptions(): Promise<ReferralOption[]> {
    const response = await api.get('/referrals/options');
    return response.data;
  },

  async getReferral(referralId: number): Promise<Referral> {
    const response = await api.get(`/referrals/${referralId}`);
    return response.data;
  },

  async createReferral(data: ReferralCreate): Promise<Referral> {
    const response = await api.post('/referrals/', data);
    return response.data;
  },

  async updateReferral(referralId: number, data: ReferralUpdate): Promise<Referral> {
    const response = await api.put(`/referrals/${referralId}`, data);
    return response.data;
  },

  async deleteReferral(referralId: number): Promise<void> {
    await api.delete(`/referrals/${referralId}`);
  },

  async uploadLogo(referralId: number, file: File): Promise<{ s3_key: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/referrals/${referralId}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async deleteLogo(referralId: number): Promise<void> {
    await api.delete(`/referrals/${referralId}/logo`);
  },

  getLogoUrl(referralId: number): string {
    const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/?$/, '');
    return `${baseUrl}/public/referral-logo/${referralId}`;
  },
};
